'use strict';
if(!window.console) window.console = {};
if(!window.console.memory) window.console.memory = function() {};
if(!window.console.debug) window.console.debug = function() {};
if(!window.console.error) window.console.error = function() {};
if(!window.console.info) window.console.info = function() {};
if(!window.console.log) window.console.log = function() {};

var breakpoints = {
  screenXs: 480,
  screenSm: 768,
  screenMd: 992,
};

var hidePopup = function() {
    var wide = $('.popup:visible').hasClass('wide');
    var widePopupWidth = 640;
    if(wide && $(window).width() < 640) {
        widePopupWidth = $(window).width() + scrollbarWidth;
    }
    $('.popup-wrapper').css({
        transition: 'background .5s',
        background: 'transparent'
    });
    $('.popup:visible').velocity({
        translateX: [0, wide ? -widePopupWidth : -320]
    }, {
        display: 'none',
        duration: 250,
        complete: function() {
            $(document.body).css({
                overflow: 'auto'
            }).removeClass('popup-visible');
            $('#header').removeClass('popup-visible');
            $('.popup-wrapper').hide().css({
                transition: 'none'
            });
        }
    });
};
var showPopup = function($popup) {
    var wide = $popup.hasClass('wide');
    var widePopupWidth = 640;
    if(wide && $(window).width() < 640) {
        widePopupWidth = $(window).width() + scrollbarWidth;
    }
    $('.popup-wrapper').velocity({
        backgroundColorRed: [0, 0],
        backgroundColorGreen: [0, 0],
        backgroundColorBlue: [0, 0],
        backgroundColorAlpha: [.77, 0]
    }, {
        duration: 250,
        display: 'block',
        begin: function() {
            $(this).css({
                top: $(document).scrollTop()
            });
        }
    });
    $popup.velocity({
        translateX: [wide ? -widePopupWidth : -320, 0]
    }, {
        display: 'block',
        duration: 250,
        begin: function() {
            $(this).css({
                opacity: 1
            });
            $(document.body).css({
                overflow: 'hidden'
            }).addClass('popup-visible');
            $('#header').addClass('popup-visible');
        }
    });
};
var changePopup = function($popup) {
    var wide = $popup.hasClass('wide');
    var widePopupWidth = 640;
    if(wide && $(window).width() < 640) {
        widePopupWidth = $(window).width() + scrollbarWidth;
    }
    $('.popup:visible').velocity('fadeOut', {
        duration: 500
    });
    $popup.velocity('fadeIn', {
        duration: 500,
        begin: function() {
            var transform = {};
            transform[Modernizr.prefixed('transform')] = "translateX(-" + (wide ? widePopupWidth : 320) + "px)";
            console.log(transform, this);
            $(this).css(transform);
        }
    });
};

// scroll wifth
//-----------------------------------------------------------------------------
(function() {
  var inner = document.createElement('p');
  inner.style.width = "100%";
  inner.style.height = "200px";

  var outer = document.createElement('div');
  outer.style.position = "absolute";
  outer.style.top = "0px";
  outer.style.left = "0px";
  outer.style.visibility = "hidden";
  outer.style.width = "200px";
  outer.style.height = "150px";
  outer.style.overflow = "hidden";
  outer.appendChild (inner);

  document.body.appendChild (outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 == w2) w2 = outer.clientWidth;

  document.body.removeChild (outer);

  window.scrollbarWidth = (w1 - w2);

  $('<style/>').text('.popup-visible{padding-right:' + window.scrollbarWidth + 'px;}').appendTo('head');
})();

// sticky footer
//-----------------------------------------------------------------------------
if(!Modernizr.flexbox) {
  (function() {
    var
      $pageWrapper = $('#page-wrapper'),
      $pageBody = $('#page-body'),
      noFlexboxStickyFooter = function() {
        $pageBody.height('auto');
        if($pageBody.height() + $('#header').outerHeight() + $('#footer').outerHeight() < $(window).height()) {
          $pageBody.height($(window).height() - $('#header').outerHeight() - $('#footer').outerHeight());
        } else {
          $pageWrapper.height('auto');
        }
      };
    $(window).on('load resize', noFlexboxStickyFooter);
  })();
}
if(ieDetector.ieVersion == 10 || ieDetector.ieVersion == 11) {
  (function(){
    var
      $pageWrapper = $('#page-wrapper'),
      $pageBody = $('#page-body'),
      ieFlexboxFix = function() {
        if($pageBody.addClass('flex-none').height() + $('#header').outerHeight() + $('#footer').outerHeight() < $(window).height()) {
          $pageWrapper.height($(window).height());
          $pageBody.removeClass('flex-none');
        } else {
          $pageWrapper.height('auto');
        }
      };
    ieFlexboxFix();
    $(window).on('load resize', ieFlexboxFix);
  })();
}

$(function() {



  //  chose payment
//-----------------------------------------------------------------------------
$('.choose-payment-radio-btn').on('change', function(){
  var $this = $(this),
    $mainId = $(this).data('href');
  if( ! $this.hasClass('checked')) {
    $('.tab-payment').css('display' , 'none');
    $($mainId).fadeIn();
  }
});

//  validate
//-----------------------------------------------------------------------------
  $("#feedBackForm").validate({
    rules: {
      name: {
        required: true,
        minlength: 2
      },
      email: {
        required: true,
        email: true
      },
      message: {
        required: true
      }
    },
    messages: {
      name: {
        required: "Please enter a name"
      },
      email: {
        required: "Please enter a email"
      },
      message: {
        required: "Please enter a message"
      }
    }
  });


  $("#profileInfo").validate({
    rules: {
      fullName: {
        required: true,
        minlength: 2
      },
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      name: {
        required: "Please enter a name"
      },
      email: {
        required: "Please enter a email"
      }
    }
  });


  $("#feedBackForm").validate({
    rules: {
      name: {
        required: true,
        minlength: 2
      },
      email: {
        required: true,
        email: true
      },
      message: {
        required: true
      }
    },
    messages: {
      name: {
        required: "Please enter a name"
      },
      email: {
        required: "Please enter a email"
      },
      message: {
        required: "Please enter a message"
      }
    }
  });



  $("#sign-up-form").validate({
    rules: {
      username: {
        required: true,
        minlength: 2
      },
      password: {
        required: true,
        minlength: 5
      },
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      username: {
        required: "Please enter a username",
        minlength: "Your username must consist of at least 2 characters"
      },
      password: {
        required: "Please provide a password",
        minlength: "Your password must be at least 5 characters long"
      },
      email: "Please enter a valid email address"
    }
  });

/*  $("#capsulate-link-form").validate({
    rules: {
      url: {
        required: true,
        url: true
      }
    },
    messages: {
      url: "Please enter a valid url"
    }
  });*/
  $("#add-folder-form").validate({
    rules: {
      folderName: {
        required: true,
        minlength: 3,
        maxlength: 12
      }
    },
    messages: {
      folderName: "Please enter a valid folder name"
    }
  });
  $("#forgot-password-form").validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: "Please enter a valid email address"
    }
  });


  $("#sign-in-form").validate({
    rules: {
      username: {
        required: true,
        minlength: 2
      },
      password: {
        required: true,
        minlength: 5
      }
    },
    messages: {
      username: {
        required: "Please enter a username",
        minlength: "Your username must consist of at least 2 characters"
      },
      password: {
        required: "Please provide a password",
        minlength: "Your password must be at least 5 characters long"
      }
    }
  });


  $("#share-capsule-mail-form").validate({
    rules: {
      login: {
        required: true,
        minlength: 2
      }
    },
    messages: {
      login: {
        required: "Please enter a names or emails",
        minlength: "Your username must consist of at least 2 characters"
      }
    }
  });
  $("#capsulate-link-form").validate({
    rules: {
      linkUrl: {
        required: true,
        url: true
      }
    },
    messages: {
      linkUrl: {
        url: "Please enter a valid url"
      }
    }
  });



  if( 'devicePixelRatio' in window && window.devicePixelRatio == 2 ){
    var retinaImage = $( 'img.retina' ).get();

    for (var i=0,l=retinaImage.length; i<l; i++) {
      var src = retinaImage[i].src;
      src = src.replace(/\.(png|jpg|gif)+$/i, '@2x.$1');
      retinaImage[i].src = src;
    }
  }


  // save/edit
//-----------------------------------------------------------------------------
  $('body').on('change paste keyup', '.link-field.spec-field', function(){
      $(this).siblings('.button-save-action').addClass('active').text('SAVE');
      $(this).siblings('.button-cancel-action').addClass('active');
  });

  $('body').on('click', '.button-edit-field', function(){
    var $this = $(this);
    if($this.hasClass('active')) {
      $this.removeClass('active').text('EDIT');
    } else {
      $this.siblings('input').focus();
    }
  });





  // search block
//-----------------------------------------------------------------------------

  $('.show-search-link').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    var fieldSearch = $(this).siblings('form').find('.search-field');
    if($(fieldSearch).is(':visible')){
      fieldSearch.fadeOut();
    } else {
      fieldSearch.fadeIn(function() {
        $(document).on('click.notSearch', function (e) {
          if ($(e.target).closest(fieldSearch).length == 0) {
            $(fieldSearch).fadeOut();
            $(document).off('click.notSearch');
          }
        });
        fieldSearch.find('input[type=text]').focus();
      });
    }
  });



  // power-tip
//-----------------------------------------------------------------------------
//  var folderTip = $('.additional-folder ').find('.power-tip');

  $('.power-tip').powerTip({
    placement: 's'
  });


  $('.power-tip').on({
    powerTipRender: function() {
      $('#powerTip').addClass('main-powerTip');
    }
  });

// dropdown
//-----------------------------------------------------------------------------
  $('body').on('click', '[data-dropdown]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $caller = $(this);
    var $dropdown = $($caller.data('dropdown'));
    if($caller.hasClass('disabled')) {

    } else {
      $.powerTip.hide();
      $('.power-tip').powerTip({
        manual: true
      });
      if($($dropdown).is(':visible')) {
        $('.power-tip').powerTip({
          placement: 's'
        });

        $dropdown.fadeOut();
        $caller.removeClass('active');



      } else {
        $('.dropdown:visible').fadeOut();
        $caller.addClass('active');
        $(document).on('click.dropdown', function(e) {
          var $target = $(e.target);
          if(!$target.closest('.dropdown').length) {
            $caller.removeClass('active');
            $dropdown.fadeOut(function() {
              $(document).off('click.dropdown');
            });
            $('.power-tip').powerTip({
              placement: 's'
            });
          }
        });
        if($caller.data('dropdown-right-regular') !== undefined ) {
          $dropdown.css({
            top: $caller.offset().top + $caller.height() + 8,

            left:  $caller.offset().left + $caller.width() - $dropdown.width()


          }).fadeIn(200);
//        console.log($caller.offset().left + $caller.width() - $dropdown.width());
        } else {
          $dropdown.css({
            top: $caller.offset().top + $caller.height() + 8,
            left: ($caller.data('dropdown-right') !== undefined /*&& $(window).width() >= breakpoints.screenSm*/) ? $caller.offset().left + $caller.width() - $dropdown.width() : $caller.offset().left
          }).fadeIn(200);
        }
      }
    }


  });
  $(window).load(function(){
    $(".dropdown > ul").mCustomScrollbar({
      scrollInertia: 100
    });
  });

// popup
//-----------------------------------------------------------------------------
  $('body').on('click', '[data-popup]', function(e) {
    e.preventDefault();
    if($('.popup:visible').length) {
      changePopup($($(this).data('popup')));
    } else {
      showPopup($($(this).data('popup')));
    }
  });
  $('#popup-wrapper').on('click', function(e) {
    if(!$(e.target).closest('.popup').length) {
      hidePopup();
    }
  });
  $('body').on('click', '.popup .close-button, .popup .close', function(e) {
    e.preventDefault();
    hidePopup();
  });

// done-info form
//-----------------------------------------------------------------------------

  $('[data-done-info]').on('click', function(e) {
    e.preventDefault();
    if( ! $($(this).data('done-info')).is(':visible')) {
      $($(this).data('done-info')).slideDown();
      setTimeout(function() {
        $('.info-window').slideUp();
      }, 3500);
    }
  });
// done-drop-point
//-----------------------------------------------------------------------------

  $('[data-drop-point]').on('click', function(e) {
    e.preventDefault();
    var $this = $(this),
        $dataId = $this.closest('.dropdown').attr('id'),
        $dataLink = $(".drop-down-button.active[data-dropdown=#" + $dataId + "]").removeClass('active'),
      $textPoint = $this.text();
      ;
//      console.log($dataLink);
    $dataLink.text($textPoint);
    $this.closest('.dropdown').fadeOut();
    $this.closest('.dropdown').find('li').removeClass('active');
    $this.closest('li').addClass('active');
  });

// editing form
//-----------------------------------------------------------------------------
  $('[data-edit]').on('click', function(e) {
    e.preventDefault();
    $($(this).data('edit')).fadeIn(function(){
      $(this).find('textarea').autosize();
    });
    var editForm = $(this).data('edit');
    if($(editForm).is(':visible')) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });
  // editing form
//-----------------------------------------------------------------------------
  $('.button-cancel').on('click', function(e) {
    e.preventDefault();
    var editForm = $(this).closest('form'),
        formId = $(this).closest('form').attr('id'),
        editBtn = $('.edit[data-edit="#' + formId + '"]');
      console.log('cancel here');
    $(editBtn).removeClass('active');
    $($(editForm)).fadeOut(function(){
      $(this).find('textarea').autosize();
    });
  });

// placeholder
//-----------------------------------------------------------------------------
  $('input[placeholder], textarea[placeholder]').placeholder();
  //$('textarea').autosize();
    $('body').on('focus', '.editing-form textarea', function() {
            $(this).closest('.editing-form').addClass('focus');
    });
    $('body').on('blur', '.editing-form textarea', function() {
        $(this).closest('.editing-form').removeClass('focus');
    });

// clipboard
//-----------------------------------------------------------------------------
//  $('[data-clipboard-target]').each(function() {
//    var self = this;
//    var client = new ZeroClipboard(self);
//      client.on( "ready", function( readyEvent ) {
//        client.on( "aftercopy", function( event ) {
//          $('#' + $(self).data('clipboard-target')).addClass('copied');
//          setTimeout(function() {
//            $('.link-animation').removeClass('copied');
//          }, 500);
//        } );
//      } );
//  });

// canvas preloader
//-----------------------------------------------------------------------------
if($('.preloader-block').length ) {
  var cl = new CanvasLoader('canvasloader-container');
  cl.setColor('#c1c1c1'); // default is '#000000'
  cl.setShape('square'); // default is 'oval'
  cl.setDiameter(47); // default is 40
  cl.setDensity(62); // default is 40
  cl.setRange(1); // default is 1.3
  cl.setSpeed(3); // default is 2
  cl.setFPS(27); // default is 24
  cl.show(); // Hidden by default

}

  // string lenght
//-----------------------------------------------------------------------------

$('#folderName, #folderDescription, #teamName').on('keyup', function(){
    var
       field = $(this),
       formLables = $(this).closest('form').find('label'),
       id = $(this).attr('id');
    formLables.each(function(){
      var $this = $(this);
      var maxlength = 1 * $this.data('maxlength');
      if($this.attr('for') === id) {
        $this.text(maxlength - field.val().length);
      }
    });
});
  // check all
//-----------------------------------------------------------------------------
  $('.check-all-btn [type=checkbox]').on('change', function(){
    var checkbox = $(this);
    var inputCheck = $('.links-list-item input[type=checkbox]');
    if(checkbox.is(':checked')){
      $(inputCheck).each(function(){
        $(this).addClass('all-check').prop('checked', true);

      });
      $('.additional-wrapper').slideDown();
//      $(inputCheck).attr('checked', 'checked');
    } else {
      $(inputCheck).each(function(){
        $(this).removeClass('all-check').prop('checked', false);
      });
      $('.additional-wrapper').slideUp();
//      $(inputCheck).attr('checked', '');
    }

    var checked = $('.links-list-item [type=checkbox]:checked');
    $('.filter').find('.count').text(checked.length);
  });

  $('body').on('change', '.links-list-item input[type=checkbox]', function(){
    var flag = true;
    $('.links-list-item input[type=checkbox]').each(function(){
       var $this = $(this);
      if($this.prop('checked') === true) {
        flag = false;
      }
    });
    if(flag) {
      $('.check-all-btn [type=checkbox]').prop('checked', false);
      $('.additional-wrapper').slideUp();
    } else {
      $('.additional-wrapper').slideDown();
    }

    var checked = $('.links-list-item [type=checkbox]:checked');
    $('.filter').find('.count').text(checked.length);
  });
// hover
//-----------------------------------------------------------------------------



  $('.links-list-item').hover(function(){
    $(this).addClass('active');
  }, function(){
    $(this).removeClass('active');
  });
 /* $('.short-link, .link-actions .title').hover(function(){
    $(this).addClass('active');
  }, function(){
    $(this).removeClass('active');
  });
  $('.link-actions .title').hover(function(){
    $(this).addClass('active');
  }, function(){
    $(this).removeClass('active');
  });*/








//  tabs
//---------------------------------------------------------------------------------------------------

  $('.tab-nav a').on('click', function(evt){
    evt.preventDefault();
    var $this = $(this),
      $tab = $(this.hash);
    if(! $tab.is(":visible ")) {
      $this.addClass('active').closest('li').siblings().find('a').removeClass('active');
      $tab.show().siblings().hide()
    }
  });


//  formstyler
//---------------------------------------------------------------------------------------------------

  $('.formstyler').styler();

});


(function( $ ) {
  $.fn.equalheight = function() {
    Array.max = function( array ){
      return Math.max.apply( Math, array );
    };
    var heights = this.map(function() {
      $(this).height('auto');
      return $(this).height();
    }).get();
    return this.height(Array.max(heights));
  };
})(jQuery);

/*
function equalPart2(){
  if($(window).width() < 1200) {
    $('.equal-part-2').height('auto');
  } else {
    $('.equal-part-2').equalheight();
  }
}*/
function equalItem(){
  if($(window).width() < 767) {
    $('.equal-item').height('auto');
    $('.equal-item .media').height('auto');
  } else {
    $('.equal-item').equalheight();
    $('.equal-item .media').equalheight();
  }
}


$(window).on({
  load: function() {
    $('.equal-height').equalheight();
//    $('.equal-item').equalheight();
//    $('.equal-part').equalheight();
    $('.benefits-item').equalheight();
//    equalPart2();
    equalItem();
  },
  resize: function() {
    $('.equal-height').equalheight();
//    $('.equal-item').equalheight();
//    $('.equal-part').equalheight();

    $('.benefits-item').equalheight();
    $('.dropdown').hide();
//    equalPart2();
    equalItem();
  },
  scroll: function(){
    $('.dropdown').hide();
  }
});